import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { HttpLink } from 'apollo-link-http';
import fetch from 'isomorphic-fetch';

import config from '@/app.config';

const httpLink = new HttpLink({
    uri: `${config.API_URL}/graphql`,
    fetch,
});

export const apolloClient = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    connectToDevTools: true,
});

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});




// WEBPACK FOOTER //
// ./src/apollo/apollo.js